import { useGetTripSummaryQuery } from "@/redux/services/allocationApi";
import {
	Alert,
	Avatar,
	Button,
	Card,
	Flex,
	List,
	Result,
	Spin,
	Tag,
	Timeline,
	Typography,
	message
} from "antd";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import car from "@/assets/car-svgrepo-com.svg";
import { ItemText } from "../ResultPage";
import { ClockCircleOutlined, FlagTwoTone, CopyOutlined } from "@ant-design/icons";
import people from "@/assets/travelsightseeing-people-svgrepo-com.svg";
import "./style.css";
import _ from "lodash";
import copy from "copy-to-clipboard";

const dateFormat = "YYYY-MM-DD";
const { Title } = Typography;

function TripSummaryPage() {
	const { data, isError, isLoading } = useGetTripSummaryQuery();
	const [selectedDate, setSelectedDate] = useState(
		dayjs("2024-01-01").format(dateFormat)
	);

	const [summary, setSummary] = useState([]);
	const [summaryFilter, setSummaryFilter] = useState();

	const getSummaryToDisplay = (productList, date) => {
		const info = productList.map((product) => {
			return product.allocation_list.map((list) => {
				const groupedOrders = {};
				// 遍历原始数组并分组
				list.items.forEach((order) => {
					const key = order.pickup_location;
					if (!groupedOrders[key]) {
						groupedOrders[key] = {
							pickup_time: order.pickup_time,
							pickup_location: order.pickup_location,
							pickup_address: order.pickup_address,
							clients: [order.client_name],
							people_no: order.people_no,
						};
					} else {
						groupedOrders[key].clients.push(order.client_name);
					}
				});

				// 将对象转换为数组
				const result = Object.values(groupedOrders);
				return {
					product_id: product.product_id,
					product_title: product.product_title,
					product_color: product.product_color,
					product_time: date,
					vehicle_plate_number: list.vehicle.vehicle_plate_number,
					driver_phone: list.driver.driver_phone,
					driver_name: list.driver.driver_name,
					pickup: result,
					people_no: list.items.reduce((c, a) => c + a.people_no, 0),
					client: list.items.map((item) => ({
						client_name: item.client_name,
						pickup_time: item.pickup_time,
						pickup_location: item.pickup_location,
						client_phone: item.client_phone,
						people_no: item.people_no,
					})),
				};
			});
		});
		const data = info.flat();

		// Create a map to group products by their title and time
		const groupedProducts = {};

		data.forEach((product) => {
			const key = `${product.product_title} - ${product.product_time}`;
			if (!groupedProducts[key]) {
				groupedProducts[key] = [];
			}
			groupedProducts[key].push(product);
		});

		// Convert the grouped products into the desired format
		const result = Object.values(groupedProducts);

		return result;
		// return info.flat();
	};

	useEffect(() => {
		if (data != null) {
			setSelectedDate(dayjs(data.travel_date).format(dateFormat));
			const summaryData = getSummaryToDisplay(
				data.product_list,
				data.travel_date
			);
			setSummary(summaryData);
			setSummaryFilter(summaryData);
		}

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [data]);

	const groupInfo = [];
	summary.forEach((s) => {
		if (s.length > 0 && Array.isArray(s)) {
			groupInfo.push({
				title: s[0].product_title,
				product_id: s[0].product_id,
				product_color: s[0].product_color,
			});
		}
	});

	const handleFilter = (info) => {
		if (info.product_id === "all") {
			const filter = _.cloneDeep(summary);
			setSummaryFilter(filter);
			return;
		}

		let filter = [];
		summary.forEach((s) => {
			if (s.length > 0 && Array.isArray(s) && filter.length === 0) {
				if (s[0].product_id === info.product_id) {
					filter = s;
				}
			}
		});
		console.log("filter", info, filter);
		setSummaryFilter([filter]);
	};

	const handleCopy = (basicTravlInfo) => {
		copy(basicTravlInfo);
		message.success("已复制到剪贴板");
	};

	return (
		<div style={{ paddingBottom: "100px" }}>
			<Flex
				gap="large"
				justify="center"
				align="center"
				style={{ marginTop: "30px" }}
			>
				<Title>
					{" "}
					墨尔本日游 发车汇总信息 -{" "}
					{dayjs(selectedDate, dateFormat).format("M")}月
					{dayjs(selectedDate, dateFormat).format("DD")}日{" "}
				</Title>
			</Flex>

			{/* <div
				style={{
					marginTop: "20px",
					display: "flex",
					justifyContent: "center",
					alignItems: "center",
				}}
			>
				<Button danger>请点击下面 - 筛选旅行项目</Button>
			</div> */}
			<div
				style={{
					padding: "20px",
					marginBottom: "30px",
					display: "flex",
					justifyContent: "center",
					alignItems: "center",
					flexWrap: "wrap",
					gap: "10px",
					// borderBottom: "1px solid #722ED1",
				}}
			>
				<Button
					style={{
						border: "1px solid #000000",
						color: "#000000",
					}}
					onClick={() =>
						handleFilter({ product_id: "all", title: "all" })
					}
				>
					所有
				</Button>
				{groupInfo.map((info) => (
					<Button
						style={{
							border: `1px solid ${info.product_color}`,
							color: `${info.product_color}`,
						}}
						onClick={() => handleFilter(info)}
					>
						{info.title}
					</Button>
				))}
			</div>

			{isError && (
				<Alert
					message="Error"
					description="Something went wrong ..."
					type="error"
					showIcon
				/>
			)}

			{isLoading && (
				<Flex
					justify="center"
					align="center"
					style={{ width: "100%", height: "50vh" }}
				>
					<Spin size="large" />
				</Flex>
			)}

			{summaryFilter?.length === 0 && !isLoading && (
				<Result
					status="500"
					title="No Data"
					subTitle="hmmmm, there's no data for the selected date"
				/>
			)}

			{summaryFilter?.map((productGroup, groupIndex) => {
				const product_title =
					productGroup.length > 0 ? (
						<Flex gap="20px" justify="flex-start" align="center">
							<FlagTwoTone style={{ fontSize: "26px" }} />
							<div>{productGroup[0]?.product_title}</div>
						</Flex>
					) : (
						""
					);

				const product_color =
					productGroup.length > 0
						? productGroup[0]?.product_color
						: "";

				return (
					<Card
						key={groupIndex}
						// title={product_title}
						title={
							<div className="custom-card-title">
								{product_title}
							</div>
						}
						style={{
							margin: "20px",
							boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
							border: "1px solid black",
						}}
						styles={{
							header: {
								backgroundColor: `${product_color}`,
							},
						}}
					>
						<div
							style={{
								display: "flex",
								flexDirection: "row",
								flexWrap: "wrap",
								gap: "10px",
								justifyContent: "center",
								margin: "10px",
							}}
						>
							{productGroup.map((product, productIndex) => {
								const travel = [
									{
										label: product.product_time,
										children: "一起来探索墨尔本！",
										color: "green",
									},
								];

								product.pickup.forEach((pickup) => {
									travel.push({
										dot: (
											<ClockCircleOutlined
												style={{ fontSize: "16px" }}
											/>
										),
										label: (
											<div>
												<ItemText
													text={pickup.pickup_time}
												/>
												<ItemText
													text={"地点："}
													value={
														pickup.pickup_location
													}
												/>
												{pickup.pickup_address && (
													<ItemText
														text={"地址："}
														value={
															pickup.pickup_address
														}
													/>
												)}
											</div>
										),
										children: (
											<div style={{ minHeight: "100px" }}>
												<div
													style={{
														display: "flex",
														flexDirection: "row",
														justifyContent:
															"space-between",
														alignItems: "center",
													}}
												>
													<Avatar
														src={people}
														style={{
															width: "40px",
															height: "40px",
															marginBottom:
																"10px",
														}}
													/>
													<Button
														// type="primary"
														icon={<CopyOutlined />}
														onClick={() => {
															let basicTravlInfo =
																"车辆号码： " +
																product.vehicle_plate_number +
																"\n" +
																"司机名字： " +
																product.driver_name +
																"\n" +
																"司机电话： " +
																product.driver_phone +
																"\n" +
																"参考坐标： " +
																pickup.pickup_location +
																"\n" +
																"上车地址： " +
																pickup.pickup_address +
																"\n" +
																"上车时间： " +
																pickup.pickup_time +
																"\n";
															handleCopy(
																basicTravlInfo
															);
														}}
													/>
												</div>
												<ul
													style={{
														padding: 0,
													}}
												>
													{pickup.clients.map(
														(c, index) => (
															<li
																key={index}
																style={{
																	listStyleType:
																		"decimal",
																}}
															>
																{c}
															</li>
														)
													)}
												</ul>
											</div>
										),
									});
								});

								return (
									<>
										<Card
											key={productIndex}
											style={{
												border: "1px solid black",
												// flexBasis: "30%",
												// maxWidth: "30%",
												width: "450px",
											}}
											hoverable
										>
											<List
												itemLayout="horizontal"
												dataSource={[{ title: "" }]}
												renderItem={(item, index) => (
													<List.Item key={index}>
														<List.Item.Meta
															avatar={
																<Avatar
																	src={car}
																/>
															}
															title={
																<div>
																	<div>
																		车辆：
																		<Tag color="orange">
																			{
																				product.vehicle_plate_number
																			}
																		</Tag>
																	</div>
																	<div>
																		出行时间：
																		{
																			product.product_time
																		}
																	</div>
																	<div>
																		司导：
																		{
																			product.driver_name
																		}
																	</div>
																	<div>
																		电话：
																		{
																			product.driver_phone
																		}
																	</div>
																</div>
															}
															description=""
														/>
													</List.Item>
												)}
											/>
											<div
												style={{
													marginTop: "30px",
													marginLeft: "10px",
													marginRight: "10px",
												}}
											>
												<Timeline
													mode="left"
													items={travel}
												/>
											</div>
										</Card>
									</>
								);
							})}
						</div>
					</Card>
				);
			})}
		</div>
	);
}

export default TripSummaryPage;
